'use strict';/* global define */define('modules/download/services/download-meta/index',['require','exports','module'],function(require,exports,module){'use strict';/**
   * Return the ngResource object
   * for the download meta service
   */// @ngInject
factory.$inject = ["$resource", "API_ENDPOINT"];
function factory($resource,API_ENDPOINT){// jshint validthis:true
// jshint latedef:false
var DownloadMeta=$resource(API_ENDPOINT+'exports/metadata/:type',{type:'@type'});return{query:DownloadMeta.query};// ---
}module.exports=factory;});
